import {Action} from '@ngrx/store';

export const EUIFRConnections = {

  UpdateFRConfiguration: 'Update FR configuration',
  GetFRConfigurations: 'Get FR Configurations for update',
  GetFRConfigurationsSuccess: 'GET FR CONFIGURATIONS SUCCESS',
  UpdateFRConfigurationSuccess: 'Update FR was succesful'
};




export class GetFRConfigurations implements Action {
  public readonly type = EUIFRConnections.GetFRConfigurations;

  constructor() {
  }
}


export class GetFRConfigurationsSuccess implements Action {
  public readonly type = EUIFRConnections.GetFRConfigurationsSuccess;

  constructor(public payload: IFormsRecognizer[]) {
  }
}

export class UpdateFRConfiguration implements Action {
  public readonly type = EUIFRConnections.UpdateFRConfiguration;

  constructor(public payload: IFormsRecognizer, public guid: string) {
  }

}

export class UpdateFRConfigurationSuccess implements Action {
  public readonly type = EUIFRConnections.UpdateFRConfigurationSuccess;

  constructor(public payload: boolean) {
  }

}






